import PrintingRoute from "@/views/admin/printer/PrintingRoute";

export default {
  path: "printers/printing-routes",
  name: "printing-routes",
  component: PrintingRoute,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
